import React, { useEffect, useState } from 'react';
import { AppInputField } from '../../../general/AppInputField/AppInputField';
import { Search } from 'react-feather';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import { TradeReference } from '@dill/dill-shared';
import { getTradeReferences } from '../../../../redux/services/tradeReferenceService';
import TradeReferencesTable from './TradeReferencesTable';
import { AppTradeRefCSVModal } from './AppTradeRefCSVModal/AppTradeRefCSVModal';

const TradeReferencesPool = () => {
  const dispatch = useAppDispatch();
  const [searchText, setSearchText] = useState('');
  const [searchedTradeReferences, setSearchedTradeReferences] = useState<TradeReference[]>([]);
  const [tradeRefModal, setTradeRefModal] = useState(false);

  const { tradeReferences } = useAppSelector((state) => state.tradeReferences);
  const { user } = useAppSelector((state) => state.auth);
  const currentSupplier = useAppSelector((state) => state.auth.currentSupplier);

  useEffect(() => {
    if (!currentSupplier?.id) return;
    dispatch(getTradeReferences({ supplierId: currentSupplier?.id ?? '' }));
  }, [currentSupplier?.id]);

  useEffect(() => {
    if (tradeReferences || searchText) {
      const tradeReferencesCopy = tradeReferences.map((tradeReference) => {
        return {
          ...tradeReference,
        };
      });

      const searched = tradeReferencesCopy.filter((tradeReference) => {
        const emails = (tradeReference.emails ?? [])?.map((email) => email.value).join(', ');
        const phones = (tradeReference.phoneNumbers ?? [])?.map((phone) => phone.value).join(', ');
        const address = `${tradeReference.address ? `${tradeReference.address},` : ''} ${
          tradeReference.city ? `${tradeReference.city},` : ''
        } ${tradeReference.state} ${tradeReference.zipCode}`.trim();
        const name = tradeReference?.originalName ?? '';
        if (
          emails.toString().toLowerCase().includes(searchText.toLowerCase()) ||
          phones.toString().toLowerCase().includes(searchText.toLowerCase()) ||
          address.toString().toLowerCase().includes(searchText.toLowerCase()) ||
          name.toString().toLowerCase().includes(searchText.toLowerCase())
        ) {
          return true;
        }
        return false;
      });
      setSearchedTradeReferences(searched);
    }
  }, [tradeReferences, searchText, user]);

  return (
    <div className="h-full p-4 flex ">
      <AppTradeRefCSVModal open={tradeRefModal} handleClose={() => setTradeRefModal(false)} />
      <div className="flex flex-col h-full w-full">
        <TradeReferencesTable
          tradeReferences={searchedTradeReferences}
          onUploadClick={() => setTradeRefModal(true)}
        />
      </div>
    </div>
  );
};

export default TradeReferencesPool;
